export default function (): boolean {
    return import.meta.client ? window !== window.top : false
}
